

<section class="unsubscribed">
    <p *ngIf="unsubscribed$ | async">You have been unsubscribed!</p>
    <p *ngIf="errored$ | async">Sorry, something went wrong. Please try again.</p>
 </section>   
    